import React, { useState } from "react";
import { bool, shape, string } from "prop-types";
import Button from "pages/_components/Button";
import { useDispatch } from "react-redux";
import Drawer from "pages/_components/Drawer/Drawer";
import TableFrequentDestination from "pages/frequentDestination/_components/TableFrequentDestination";
import { actions as cedipActions } from "reducers/cedip";
import Avatar from "pages/_components/Avatar";
import GridTable from "pages/_components/GridTable/GridTable";
import AddBeneficiary from "./AddBeneficiary";

const FORM_ID = "cedip.transmit";

const Beneficiaries = ({ isDesktop, beneficiaryData, actionType }) => {
    const dispatch = useDispatch();

    const [openSidebarList, setOpenSidebarList] = useState(false);
    const [openSidebarForm, setOpenSidebarForm] = useState(false);

    const selectBeneficiary = (beneficiary) => {
        dispatch(
            cedipActions.beneficiaryCedip(
                {
                    document:
                        beneficiary?.document ||
                        `${beneficiary?.recipientDocumentType} ${beneficiary?.recipientDocumentNumber}`,
                    reference: beneficiary?.headline || beneficiary?.recipientName,
                },
                actionType,
            ),
        );

        setOpenSidebarList(false);
    };

    const cleanBeneficiary = () => {
        dispatch(cedipActions.beneficiaryCedip({}, actionType));
    };

    return (
        <>
            <GridTable className="echeck beneficiaries">
                <GridTable.Container columns={12} columnsTemplate="fixed" className="mb-4">
                    <GridTable.Data columnStart={1} columnWidth={isDesktop ? 4 : 12} rowStart={1}>
                        {/* <Button
                            className="btn-outline px-2"
                            label="echecks.search.contact"
                            onClick={() => setOpenSidebarList(true)}
                        /> */}
                        <Button
                            className="btn-outline px-2"
                            label="cedip.new.beneficiary"
                            onClick={() => setOpenSidebarForm(true)}
                        />
                    </GridTable.Data>
                    {/* <GridTable.Data
                        columnStart={isDesktop ? 5 : 1}
                        columnWidth={isDesktop ? 4 : 12}
                        rowStart={isDesktop ? 1 : 2}>
                        <Button
                            className="btn-outline px-2"
                            label="echecks.new.contact"
                            onClick={() => setOpenSidebarForm(true)}
                        />
                    </GridTable.Data> */}
                </GridTable.Container>
                {beneficiaryData?.beneficiary?.reference && (
                    <GridTable.Container className="beneficiary box border blocktag mb-4">
                        <GridTable.Data columnStart={1} columnWidth={1}>
                            <Avatar
                                user={{
                                    userFullName: beneficiaryData?.beneficiary?.reference,
                                    defaultAvatarId: 0,
                                    email: beneficiaryData?.beneficiary?.email,
                                }}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} columnWidth={9} alignY="center">
                            <b className="primary">
                                {`${beneficiaryData?.beneficiary?.document} - ${beneficiaryData?.beneficiary?.reference}`}
                            </b>
                        </GridTable.Data>
                        <GridTable.Data columnStart={12} columnWidth={1} className="close" alignX="end" alignY="center">
                            <Button
                                onClick={() => cleanBeneficiary()}
                                image="images/figma/icon/cross.svg"
                                bsStyle="link close"
                                block={false}
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                )}
            </GridTable>
            <Drawer openSidebar={openSidebarList} toggleSidebar={setOpenSidebarList}>
                <TableFrequentDestination
                    formId={FORM_ID}
                    onRowClick={selectBeneficiary}
                    searchClassName="d-flex flex-column"
                    isDesktop={isDesktop}
                    fromModal
                />
            </Drawer>
            <Drawer openSidebar={openSidebarForm} toggleSidebar={setOpenSidebarForm}>
                <AddBeneficiary type={actionType} setOpenSidebarForm={setOpenSidebarForm} />
            </Drawer>
        </>
    );
};

Beneficiaries.propTypes = {
    isDesktop: bool.isRequired,
    actionType: string.isRequired,
    beneficiaryData: shape({}),
};

Beneficiaries.defaultProps = {
    beneficiaryData: {},
};

export default Beneficiaries;
